'use strict'

const watermark = {}

/**
 * 创建固定全屏水印
 * @param {要设置的水印的内容} str
 * @param {需要设置水印的容器} container
 */
const setWatermark = (str, container) => {
  const id = '1.23452384164.123412415'

  //字体颜色
  const fontColor = 'rgba(255, 63, 63, 0.86)'


  if (container === undefined) {
    return
  }

  // 查看页面上有没有，如果有则删除
  if (document.getElementById(id) !== null) {
    const childelement = document.getElementById(id)
    childelement.parentNode.removeChild(childelement)
  }

  // 创建canvas元素(先制作一块背景图)
  const can = document.createElement('canvas')
  can.width = 300 // 优化：减小水印块宽度，让水印更密集
  can.height = 150 // 优化：减小水印块高度
  const cans = can.getContext('2d') // 获取canvas画布
  
  // 优化：设置更好的字体和样式
  cans.rotate(-15 * Math.PI / 180) // 优化：调整旋转角度为-15度，更美观
  cans.font = 'bold 16px "Microsoft YaHei", "PingFang SC", "Helvetica Neue", Arial, sans-serif' // 优化：使用更好的字体
  cans.fillStyle = fontColor // 优化：使用更淡的黑色，提高可读性
  cans.textAlign = 'center' // 优化：居中对齐
  cans.textBaseline = 'middle' // 优化：垂直居中
  
  // 优化：绘制主文字
  cans.fillText(str, can.width / 2, can.height / 2)
  
  // 优化：添加副标题或时间戳
  cans.font = 'normal 12px "Microsoft YaHei", "PingFang SC", "Helvetica Neue", Arial, sans-serif'
  cans.fillStyle = fontColor
  const currentDate = new Date().toLocaleDateString('zh-CN')
  cans.fillText(currentDate, can.width / 2, can.height / 2 + 25)

  // 创建固定全屏水印div元素
  const div = document.createElement('div')
  div.id = id // 设置id
  div.style.pointerEvents = 'none' // 取消所有事件
  div.style.top = '0px'
  div.style.left = '0px'
  div.style.position = 'fixed' // 关键：使用fixed定位，固定在屏幕上不随滚动
  div.style.zIndex = '100000'
  div.style.width = '100vw' // 使用视口宽度单位，确保覆盖整个屏幕宽度
  div.style.height = '100vh' // 使用视口高度单位，确保覆盖整个屏幕高度
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
  div.style.userSelect = 'none' // 优化：禁止选择文本
  div.style.webkitUserSelect = 'none' // 优化：兼容webkit内核
  div.style.mozUserSelect = 'none' // 优化：兼容firefox
  div.style.msUserSelect = 'none' // 优化：兼容IE
  div.style.overflow = 'hidden' // 优化：隐藏溢出内容
  
  // 将水印添加到body，确保覆盖整个页面且不受容器限制
  document.body.appendChild(div)

  return id
}

// 优化：添加防篡改和响应式功能
watermark.set = (str, container) => {
  let id = setWatermark(str, container)
  
  // 优化：使用更高效的监听间隔，防止水印被删除
  const checkInterval = setInterval(() => {
    if (document.getElementById(id) === null) {
      id = setWatermark(str, container)
    }
  }, 1000) // 优化：从500ms改为1000ms，减少性能消耗
  
  // 优化：防抖处理窗口大小变化
  let resizeTimer = null
  const handleResize = () => {
    if (resizeTimer) {
      clearTimeout(resizeTimer)
    }
    resizeTimer = setTimeout(() => {
      const existingElement = document.getElementById(id)
      if (existingElement) {
        existingElement.parentNode.removeChild(existingElement)
      }
      id = setWatermark(str, container)
    }, 300) // 优化：300ms防抖延迟
  }
  
  // 优化：移除旧的resize监听器，避免重复绑定
  if (window.watermarkResizeHandler) {
    window.removeEventListener('resize', window.watermarkResizeHandler)
  }
  window.watermarkResizeHandler = handleResize
  window.addEventListener('resize', handleResize)
  
  // 优化：返回清理函数，方便组件销毁时清理
  return () => {
    if (checkInterval) {
      clearInterval(checkInterval)
    }
    if (window.watermarkResizeHandler) {
      window.removeEventListener('resize', window.watermarkResizeHandler)
      window.watermarkResizeHandler = null
    }
    const element = document.getElementById(id)
    if (element) {
      element.parentNode.removeChild(element)
    }
  }
}

// 优化：添加清除水印的方法
watermark.remove = () => {
  const id = '1.23452384164.123412415'
  const element = document.getElementById(id)
  if (element) {
    // 优化：无论水印添加到哪里都能正确移除
    if (element.parentNode) {
      element.parentNode.removeChild(element)
    }
  }
  
  // 清理全局事件监听器
  if (window.watermarkResizeHandler) {
    window.removeEventListener('resize', window.watermarkResizeHandler)
    window.watermarkResizeHandler = null
  }
}

// 优化：添加检查水印是否存在的方法
watermark.exists = () => {
  const id = '1.23452384164.123412415'
  return document.getElementById(id) !== null
}

export default watermark

